import { Language } from "interfaces/locale";
import { matchPath } from "react-router-dom";
import { RouteKeys, ROUTES } from "./routes";

const BASE_KEYS: RouteKeys[] = [
  "login",
  "entities",
  "passwordRecovery",
  "passwordDefinition",
  "twoFactorAuthentication",
];

const langPrefix: Record<Language, string> = {
  pt: "",
  en: "/en",
  es: "/es",
};

const HOME_PATHS = ["/", "/en", "/es"] as const;

export const baseSolutionRoutes: readonly string[] = [
  ...HOME_PATHS,
  ...(["pt", "en", "es"] as const).flatMap((lang) =>
    BASE_KEYS.map((k) => `${langPrefix[lang]}${ROUTES[lang][k]}`)
  ),
] as const;

export const isBaseSolutionRoute = (targetPathname: string): boolean => {
  return baseSolutionRoutes.some(
    (pattern) => !!matchPath({ path: pattern, end: false }, targetPathname)
  );
};
